// extracted by mini-css-extract-plugin
export default {"header":"styles_header__Dx5Qn","content":"styles_content__0jA6A","TransUp":"styles_TransUp__qou4m"};